import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  const displayCategories = categories.slice(0, 10);

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 -mt-8 relative z-20">
      <div className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/60">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-apps-2-line text-primary-500 text-sm"></i>
          </div>
          <h2 className="text-base font-semibold text-foreground-900">电影分类</h2>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-10 gap-2 md:gap-3">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-1.5 p-3 rounded-xl hover:bg-accent-50 transition-all duration-200 group cursor-pointer"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-accent-100/60 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-accent-600 text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs text-foreground-600 group-hover:text-foreground-900 whitespace-nowrap font-medium">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}